export type DeduplicationKind = 'company' | 'contact'

export type DeduplicationKindConfig = {
  kind: DeduplicationKind
  objectType: DeduplicationKind
  basePath: string
  title: string
  entityLabel: string
  entityCountLabel: string
  secondaryFieldLabel: string
  reducedLabel: string
  manualRunsEnabled: boolean
  settingsPath?: string
  runDescription: string
}

export const deduplicationKindConfig: Record<DeduplicationKind, DeduplicationKindConfig> = {
  company: {
    kind: 'company',
    objectType: 'company',
    basePath: '/de-duplication/companies',
    title: 'Company De-duplication',
    entityLabel: 'Company',
    entityCountLabel: 'Companies',
    secondaryFieldLabel: 'Domain',
    reducedLabel: 'Companies reduced',
    manualRunsEnabled: true,
    settingsPath: '/de-duplication/companies/settings',
    runDescription:
      'This starts a full company de-duplication run in the background. It discovers duplicate groups in HubSpot, crawls domains, decides per group, and executes HubSpot changes in-process via the coordinator.',
  },
  contact: {
    kind: 'contact',
    objectType: 'contact',
    basePath: '/de-duplication/contacts',
    title: 'Contact De-duplication',
    entityLabel: 'Contact',
    entityCountLabel: 'Contacts',
    secondaryFieldLabel: 'LinkedIn',
    reducedLabel: 'Contacts merged',
    manualRunsEnabled: true,
    runDescription:
      'This starts a contact de-duplication run in the background. It scores duplicate LinkedIn pairs, auto-merges high-confidence matches, and flags low-confidence pairs for review.',
  },
}

export const deduplicationKindFromPath = (pathname: string): DeduplicationKind =>
  pathname.includes('/de-duplication/contacts') ? 'contact' : 'company'
